import React from 'react';
import './index.scss';

export default ({ title, subtitle, Image }) => {
  return (
    <div className="HeaderComponent">
      {Image && (<div className="Header-image">
        <Image />
      </div>)}
      {title && (<h1>{title}</h1>)}
      {subtitle && (<h2>{subtitle}</h2>)}
    </div>
  );
};
